/**
 * 判断 value 是否为空，用于决定是否显示占位符。
 * 空值包括: null, undefined, 空字符串, 纯空白字符串, 空数组
 */
export function isEmptyValue(value) {
  if (value === null || value === undefined) {
    return true;
  }
  if (typeof value === 'string' && value.trim() === '') {
    return true;
  }
  if (Array.isArray(value) && value.length === 0) {
    return true;
  }
  return false;
}

/**
 * 当配置了 emptyPlaceholder 并且值为空时，返回占位符文本。
 * 支持 true（默认显示 '-'）或自定义字符串。
 * 如果不需要显示占位符，返回 null。
 */
export function getEmptyPlaceholder(emptyPlaceholder) {
  if (!emptyPlaceholder) return null;
  return typeof emptyPlaceholder === 'string' ? emptyPlaceholder : '-';
}
